module.exports = __webpack_public_path__ + "img/tokopedia.95cabc4.png";